import { render, staticRenderFns } from "./UlNode.vue?vue&type=template&id=2a850722"
import script from "./UlNode.vue?vue&type=script&lang=js"
export * from "./UlNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports